import { DateRangePicker } from './DateRangePicker';

export * from './DateRangePicker';

export default DateRangePicker;
